/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useLayout } from '../../core'
// import {KTSVG} from '../../../helpers'
import { AsideMenu } from './AsideMenu'
import { AsideToolbar } from './AsideToolbar'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { useLang } from '_metronic/i18n/Metronici18n'
import { sidebarMenuItems } from 'Configuration/Menu'

const AsideDefault: FC = () => {
	const { classes } = useLayout()
	const lang = useLang()

	return (
		<div
			id="kt_aside"
			className="aside overflow-y-auto"
			data-kt-drawer="true"
			data-kt-drawer-name="aside"
			data-kt-drawer-activate="{default: true, lg: false}"
			data-kt-drawer-overlay="true"
			data-kt-drawer-width="{default:'200px', '300px': '250px'}"
			data-kt-drawer-direction="start"
			data-kt-drawer-toggle="#kt_aside_mobile_toggle">
			{/* begin::Aside Toolbar */}
			<div className="aside-toolbar flex-column-auto" id="kt_aside_toolbar">
				<AsideToolbar />
			</div>
			{/* end::Aside Toolbar */}

			{/* begin::Aside menu */}
			<div className="aside-menu flex-sm-column-fluid min-h-400px">
				<AsideMenu asideMenuCSSClasses={classes.asideMenu} />
			</div>
			{/* end::Aside menu */}

			{/* begin:: Aside Footer */}
			<div className="aside-footer flex-column-auto py-5" id="kt_aside_footer">
				<AsideMenuItem
					// @ts-ignore
					title={sidebarMenuItems['support'][lang]}
					to="/support"
					icon="/media/icons/kumopack/books.svg"
				/>
				<AsideMenuItemWithSub
					isOutsideMenu
					to="/profile"
					// @ts-ignore
					title={sidebarMenuItems['profile'][lang]}
					icon="/media/icons/kumopack/settings-02.svg">
					<AsideMenuItem title="ข้อมูลส่วนตัว" to="/profile" hasBullet />
					<AsideMenuItem title="Member Type" to="/plans" hasBullet />
				</AsideMenuItemWithSub>

				<div className="card bg-kumopack-grey-50 mt-5">
					<div className="card-body px-5 py-2">
						{/* Header */}
						<div className="row gy-3">
							<div className="col-10">
								<div className="text-kumopack-grey-900 fw-bold">News Feature Available</div>
							</div>
							<div className="col-2">
								<div className="text-end">X</div>
							</div>

							<div className="col-12">
								<div className="text-kumopack-grey-600">
									Check out the new dashboard view. Pages now load faster.
								</div>
							</div>

							<div className="col-12 d-none d-xl-block rounded">
								<img
									className="w-100 shadow"
									src="/media/kumopack-sidebar/corrugated-boxes.png"
									alt="Corrugated Box"
									style={{ objectFit: 'cover' }}
								/>
							</div>

							<div className="col-12">
								<span className="text-kumopack-grey-600 fw-bold me-2 cursor-pointer">Dismiss</span>
								<span className="text-kumopack-primary-700 fw-bold cursor-pointer">
									What's new?
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* end:: Aside Footer */}
		</div>
	)
}

export { AsideDefault }
